module.exports = __webpack_public_path__ + "static/media/IconCorrectSecondary.29d1153d.svg";